import { Link } from "react-router-dom";
import styles from "./styles.module.css";

const CategoryCard = ({ category, link }) => {
  return (
    <Link to="/product" state={{ category }} className={styles.cardLink}>
      <div className={`${styles.card} shadow-sm h-100`}>
        <div className={styles.inner}>
          <h5 className={styles.title}>{category}</h5>

          <div className={styles.footer}>
            <span className={styles.pill}>See more</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
